import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import { adminAPI } from "@/services/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const AdminResetPassword = () => {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState(token ? "" : "This recovery link is invalid or no longer active.");
  const [complete, setComplete] = useState(false);

  useEffect(() => { window.history.replaceState(null, "", window.location.pathname); }, []);
  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirmation) { setError("Passwords do not match."); return; }
    setError("");
    try {
      await adminAPI.resetPassword(token, password);
      setPassword(""); setConfirmation(""); setComplete(true);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "This recovery link is invalid or no longer active.");
    }
  };
  return <main className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
    <section className="w-full max-w-md rounded-2xl border bg-white p-6 shadow-sm sm:p-8">
      <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-500 text-white"><ShieldCheck className="h-6 w-6" /></div>
      {complete ? <div className="space-y-4"><CheckCircle2 className="h-10 w-10 text-emerald-600" /><h1 className="text-2xl font-semibold">Password updated</h1><p className="text-sm text-gray-600">Existing admin sessions have been signed out.</p><Button asChild className="w-full"><Link to="/admin/login">Continue to admin sign in</Link></Button></div> : <>
        <h1 className="text-2xl font-semibold">Reset your staff password</h1>
        {error ? <p role="alert" className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p> : null}
        {token ? <form className="mt-6 space-y-4" onSubmit={submit}>
          <div><Label htmlFor="new-password">New password</Label><Input id="new-password" type="password" autoComplete="new-password" minLength={12} maxLength={72} required value={password} onChange={(event) => setPassword(event.target.value)} /></div>
          <div><Label htmlFor="confirm-password">Confirm password</Label><Input id="confirm-password" type="password" autoComplete="new-password" minLength={12} maxLength={72} required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} /></div>
          <p className="text-xs text-gray-500">Use uppercase, lowercase, a number, and a symbol. Maximum 72 UTF-8 bytes.</p>
          <Button className="w-full" type="submit">Reset password</Button>
        </form> : null}
      </>}
    </section>
  </main>;
};

export default AdminResetPassword;
